/**
 * Generating a triangle mesh from design material SDF patterns on top of a complex base mesh for use in three.js scenes.
 * @module
 */
import type * as THREE from "three";
import { mesh3ToTHREE, threeBufferGeometryToMesh3 } from "../../convert";
import type { SdfParamsPreprocessed } from "../designMaterialTypes";
import { generateMesh3FromDesignMaterial } from "./generateMesh3FromDesignMaterial";
import type { AdjustGeoType, MaterialLayoutInfo } from "./utils";

export function generateThreeGeometryFromDesignMaterial(
  baseGeo: THREE.BufferGeometry,
  scale: THREE.Vector3,
  adjustBaseGeo: AdjustGeoType,
  sdf: SdfParamsPreprocessed,
  currentUVLayout: MaterialLayoutInfo,
): THREE.BufferGeometry | undefined {
  const mesh3BaseGeo = threeBufferGeometryToMesh3(baseGeo);
  (baseGeo.attributes.position as THREE.BufferAttribute).needsUpdate = true; // Base mesh may get modified for walls.
  const mesh = generateMesh3FromDesignMaterial(
    mesh3BaseGeo,
    [scale.x, scale.y, scale.z],
    adjustBaseGeo,
    sdf,
    currentUVLayout,
  );
  if (mesh === undefined) {
    return undefined;
  }
  return mesh3ToTHREE(mesh).geometry;
}
